import { isNil } from 'lodash';
import OrganisationTypes from '../../../model/OrganisationTypes';
import { isRootNode } from '../dataViews/DynamicTree';
import { isDefaultRoleLevel, isRoleLevel, } from './OrganisationStructureTreeAdapter';
export const resolveNodeClassName = node => {
    const classNames = [];
    if (isRootNode(node) || OrganisationTypes.isBusinessEntity(node)) {
        classNames.push('jstree-node-bold');
        classNames.push('jstree-node-uppercase');
    }
    if (isDefaultRoleLevel(node)) {
        classNames.push('jstree-node-italic jstree-node-disabled');
    }
    if (isRoleLevel(node)) {
        classNames.push('jstree-node-italic');
    }
    return classNames.join(' ');
};
export function resolveNodeId(node) {
    if (['RoleXOrgLevel', 'OrgStructureLevel'].includes(node.__typename)) {
        return `${node.__initiatedNodeId}-${node.__typename}-${node.id}`;
    }
    return node.id || node._tempId;
}
export function resolveNodeParentId(node) {
    if (node.__typename === 'OrgStructureLevel' && isNil(node.parentId)) {
        return node.__initiatedNodeId;
    }
    if (node.__typename === 'OrgStructureLevel') {
        return `${node.__initiatedNodeId}-${node.__typename}-${node.parentId}`;
    }
    if (isDefaultRoleLevel(node) && node.__initiatedNodeId) {
        return node.__initiatedNodeId;
    }
    if (node.__typename === 'RoleXOrgLevel') {
        return `${node.__initiatedNodeId}-OrgStructureLevel-${node.orgStructureLevelId}`;
    }
    return node.parentId;
}
export function nodeIsLeaf(node) {
    return !isRootNode(node);
}
export function nodeIsSelectable(node) {
    return (!isRootNode(node) &&
        !['RoleXOrgLevel', 'OrgStructureLevel'].includes(node.__typename));
}
export default {
    nodeIsLeaf,
    resolveNodeClassName,
    resolveNodeId,
    resolveNodeParentId,
};
